export const triggerFileDownload = (
  blob: Blob,
  format: 'json' | 'csv',
  fileNamePrefix: string
) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  const dateLabel = new Date().toISOString().split('T')[0];

  link.href = objectUrl;
  link.download = `${fileNamePrefix}-${dateLabel}.${format}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};
